/* eslint-disable no-console */
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Row, Col, Card, Collapse } from "react-bootstrap";
// import { Link } from "react-router-dom";

import Loading from "../../components/Loading";
import Text from "../../components/Text";
// import Breadcrumb from "../../components/Breadcrumb";

import Aux from "../../hoc/_Aux/Aux";

const { listOfQA } = require("../../helpers/listOfQA");

class KnowledgeBase extends Component {
  state = {
    loading: true,
    isBasic: false,
    isMultiTarget: [],
    accordionKey: 0,
  };

  async componentDidMount() {
    try {
      this.setState({
        loading: false,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    const { loading } = this.state;
    // const { dictionary } = this.props.lang;
    // const { user } = this.props.auth;
    const { accordionKey } = this.state;
    const { isLoggedIn } = this.props.auth;

    const PUBLIC_IDS = [1, 3, 11, 12];
    const visibleQA = isLoggedIn
      ? listOfQA
      : listOfQA.filter((q) => PUBLIC_IDS.includes(q.id));

    return (
      <Aux>
        {/* <Breadcrumb /> */}
        {loading && <Loading />}
        {!loading && (
          <Row>
            <Col sm={12} className="accordion">
              <h5>
                <Text tid="commonQuestions" />
              </h5>
              <hr />
              {visibleQA.map((oneQuestion) => (
                <Card className="mt-2" key={oneQuestion.id}>
                  <Card.Header>
                    <Card.Title as="h5">
                      <a
                        key={oneQuestion.id}
                        onClick={() => this.setState({ accordionKey: (accordionKey !== oneQuestion.id) ? oneQuestion.id : 0 })}
                        aria-controls="accordion1"
                        aria-expanded={accordionKey === oneQuestion.id}
                      >
                        <span style={{ 'marginRight': "25px", 'background': '#04a9f5', 'paddingRight': "5px", 'paddingLeft': "5px" }}>
                          {accordionKey === oneQuestion.id ? "-" : "+"}
                        </span>
                        {oneQuestion[this.props.lang.language.id].title}
                      </a>
                    </Card.Title>
                  </Card.Header>
                  <Collapse in={this.state.accordionKey === oneQuestion.id} key={oneQuestion.id}>
                    <div id="accordion1" key={oneQuestion.id}>
                      <Card.Body>
                        <Card.Text
                          key={oneQuestion.id}
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{ __html: (!isLoggedIn && oneQuestion[this.props.lang.language.id].textGuest) ? oneQuestion[this.props.lang.language.id].textGuest : oneQuestion[this.props.lang.language.id].text }}
                        />
                        {(() => {
                          const steps = (!isLoggedIn && oneQuestion[this.props.lang.language.id].stepsGuest)
                            ? oneQuestion[this.props.lang.language.id].stepsGuest
                            : oneQuestion[this.props.lang.language.id].steps;
                          return steps ? (
                          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: 4, marginTop: 20 }}>
                            {steps.map((step, i, arr) => (
                              <React.Fragment key={i}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 88, textAlign: "center" }}>
                                  <div style={{
                                    width: 48, height: 48, borderRadius: "50%",
                                    background: "#f0f3fb",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    marginBottom: 8,
                                  }}>
                                    <i className={`feather ${step.icon}`} style={{ fontSize: 20, color: "#4e6ac5" }} />
                                  </div>
                                  <span style={{ fontSize: 11, color: "#7a8299", lineHeight: 1.3 }}>
                                    {step[this.props.lang.language.id]}
                                  </span>
                                </div>
                                {i < arr.length - 1 && (
                                  <i className="feather icon-chevron-right" style={{ fontSize: 18, color: "#c5cde8", alignSelf: "center", marginBottom: 24 }} />
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                          ) : null;
                        })()}
                      </Card.Body>
                    </div>
                  </Collapse>
                </Card>
              ))
              }
            </Col>
          </Row>
        )}
      </Aux>
    );
  }
}

KnowledgeBase.propTypes = {
  auth: PropTypes.object.isRequired,
  lang: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  lang: state.lang,
});

export default connect(mapStateToProps)(KnowledgeBase);
